<template>
  <div class="py-2">
    <a :href="`/interests/${id}`" class="text-sm font-medium text-primary-60">
      <slot />
    </a>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  id: string;
}>();
</script>
